var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notification-bing",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0V3.885",
    transform: "translate(14 7.513)",
    fill: "none",
    stroke: "#1d1640",
    strokeLinecap: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M10.4,0a7.767,7.767,0,0,0-7.77,7.77v2.45A6.058,6.058,0,0,1,1.9,12.88L.417,15.353a2.488,2.488,0,0,0,1.4,3.792,27.23,27.23,0,0,0,17.185,0,2.59,2.59,0,0,0,1.4-3.792L18.92,12.88a6.1,6.1,0,0,1-.735-2.66V7.77A7.815,7.815,0,0,0,10.4,0Z",
    transform: "translate(3.62 2.333)",
    fill: "none",
    stroke: "#1d1640",
    strokeLinecap: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M7.77,0A3.9,3.9,0,0,1,3.885,3.885,3.892,3.892,0,0,1,1.143,2.742,3.892,3.892,0,0,1,0,0",
    transform: "translate(10.115 21.957)",
    fill: "none",
    stroke: "#1d1640",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    fill: "none",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsBlack);
export default __webpack_public_path__ + "static/media/notificationsBlack.1091ded6e6178989f93dd52f26870db6.svg";
export { ForwardRef as ReactComponent };